module.exports = __webpack_public_path__ + "static/img/develop.8f439ad.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/service/develop.jpg
// module id = Egu3
// module chunks = 1